export default __webpack_public_path__ + "static/media/bauble.04602568.png";